export enum SECRET_REQUIREMENT {
  PIN = 'PIN',
  PASSWORD = 'PASSWORD',
}
